import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from './../../../../../Containers/Config/index';
import { GET_SURGE_EVENTS, GET_SURGE_EVENTS_SUCCESS, GET_SURGE_EVENTS_ERROR } from './../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* getEvents({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/event-rules`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageSize: Constant?.TABLE_PAGE_SIZE,
        ...payload.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_SURGE_EVENTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SURGE_EVENTS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SURGE_EVENTS_ERROR, payload: error });
  }
}

export function* watchGetEvents() {
  yield takeEvery(GET_SURGE_EVENTS, getEvents);
}

function* getEventsSaga() {
  yield all([fork(watchGetEvents)]);
}

export default getEventsSaga;
